const APISTATIC_HOST = process.env.NODE_ENV === 'development' ? 'http://localhost:8000/api-static/' : '/api-static/'
const APIMEDIA_HOST = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : ''
const API_HOST = process.env.NODE_ENV === 'development' ? 'http://localhost:8000/' : '/api/'

export { APISTATIC_HOST, API_HOST, APIMEDIA_HOST }